import React, { createContext, useContext, useState } from "react";

const helpContext = createContext();

export function ProvideContextualHelp({ children }) {
    const help = useProvideContextualHelp();
    return <helpContext.Provider value={help}>{children}</helpContext.Provider>;
}

export const useContextualHelp = () => {
    return useContext(helpContext);
};

function useProvideContextualHelp() {
    const [open, setOpen] = useState(false);
    const [helpPath, setHelpPath] = useState(null);

    function showContextualHelp(path = null) {
        setOpen(true);
        setHelpPath(path);
    }

    return {
        open,
        helpPath,
        setOpen,
        setHelpPath,
        showContextualHelp,
    };
}
